module.exports = __webpack_public_path__ + "static/img/RAZ25_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RAZ25_1.png
// module id = mwtc
// module chunks = 0